import { DownOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useThemeComponents } from '../../../../../themes';
import { FullScreenModal } from '../../../StandardApplicationEntrypoint/CarListingPage/CarFilter/ui';
import { useCarListingState } from '../CarListingStateProvider';
import CarFilterContent from './CarFilterContent';

const ButtonContainer = styled.div`
    & .ant-btn {
        & > svg:first-of-type {
            display: none;
        }

        & > span {
            margin: 0px;
        }

        & > span:last-child {
            position: absolute;
            right: 16px;
            top: 14px;
        }
    }
`;

const CarFilterOnSmallScreen = () => {
    const { t } = useTranslation(['carList']);
    const { Button } = useThemeComponents();

    const {
        state: { openFilterDrawer, conditionFilter, modelFilter, rangeMonthlyPaymentFilter, showFilterDrawer },
        actions,
    } = useCarListingState();

    const hasInitialized = useRef(false);

    const previousFilter = useRef<{
        conditionFilter: string[];
        modelFilter: string[];
        rangeMonthlyPaymentFilter: string[];
    }>(null);

    const onOpen = useCallback(() => {
        previousFilter.current = { conditionFilter, modelFilter, rangeMonthlyPaymentFilter };
        actions.setOpenFilterDrawer(true);
    }, [actions, conditionFilter, modelFilter, rangeMonthlyPaymentFilter]);

    const onCancel = useCallback(() => {
        actions.setOpenFilterDrawer(false);
        actions.setConditionFilter(previousFilter?.current?.conditionFilter || []);
        actions.setModelFilter(previousFilter?.current?.modelFilter || []);
        actions.setRangeMonthlyPaymentFilter(previousFilter?.current?.rangeMonthlyPaymentFilter || []);
    }, [actions]);

    const onApply = useCallback(() => {
        previousFilter.current = { conditionFilter, modelFilter, rangeMonthlyPaymentFilter };
        actions.setOpenFilterDrawer(false);
    }, [actions, conditionFilter, modelFilter, rangeMonthlyPaymentFilter]);

    useEffect(() => {
        if (!hasInitialized.current) {
            hasInitialized.current = true;
            // do not show filter by default on mobile
            actions.setOpenFilterDrawer(false);
        }
    }, [actions]);

    if (!showFilterDrawer) {
        return null;
    }

    return (
        <>
            <ButtonContainer>
                <Button onClick={onOpen} size="large" style={{ marginBottom: '1rem' }} block>
                    {t('carList:filterButton')}
                    <DownOutlined />
                </Button>
            </ButtonContainer>
            <FullScreenModal
                footer={null}
                onCancel={onCancel}
                open={openFilterDrawer}
                title={t('carList:filterTitle')}
                destroyOnClose
            >
                <CarFilterContent />
                <Button onClick={onApply} type="secondary" block>
                    {t('carList:applyFilterButton')}
                </Button>
            </FullScreenModal>
        </>
    );
};

export default CarFilterOnSmallScreen;
